import React from 'react';

const UserContext = React.createContext({
    currentUser: '',
    setCurrentUser: () => {}
});

export default UserContext;